import Primary from './Primary/Primary';

export const Button = {
  Primary
};
